/**
 * 実行環境 (VITE_APP_ENV: local / demo / prod / trial)。
 *
 * #2140 の 3 体験専用の環境 (trial) は、紹介ページから誰でも使う公開の環境。**demo でだけ出す
 * もの (模擬ボタン・開発用の表示・Web3 の切り替え) は本番と同じく出さない**。
 * サーバ側の utils/env.is_public と同じ考え方。
 */
export function isPublicEnv(): boolean {
  const env = String(import.meta.env.VITE_APP_ENV || '').trim().toLowerCase()
  return env === 'prod' || env === 'trial'
}

/**
 * #2148 demo・開発用のものを出してよい環境か。**許可の一覧。知らない値・未設定なら出さない。**
 *
 * `isPublicEnv()` は「本番か trial なら隠す」という拒否の一覧で、`VITE_APP_ENV` を
 * 付け忘れたビルド・新しい値の環境で**黙って出た**（サーバ側 #2148 と同じ問題）。
 * 新しい公開の環境を作るときは、ここに足さない限り出ない。
 *
 * サーバ側の `utils/env.demo_paths_enabled` と同じ一覧にしてある。
 */
const DEMO_UI_ENVS = ['local', 'ci', 'preview', 'demo']

export function demoUiEnabled(): boolean {
  const env = String(import.meta.env.VITE_APP_ENV || '').trim().toLowerCase()
  return DEMO_UI_ENVS.includes(env)
}
